import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';
import { browserHistory } from 'react-router';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/singleOrder/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/singleOrder/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/singleOrder/LOAD_FAILURE';

const PAY_LATER_REQUEST = 'farmakom/singleOrder/PAY_LATER_REQUEST';
const PAY_LATER_SUCCESS = 'farmakom/singleOrder/PAY_LATER_SUCCESS';
const PAY_LATER_FAILURE = 'farmakom/singleOrder/PAY_LATER_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadOrder(orderId, userEmail) {
  return {
    [RSAA]: {
      ...api.getOrderById(orderId, userEmail),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// THUNK
export function payLater(orderId, paymentTypeName) {
  return function(dispatch, getState) {
    const { endpoint, method, headers, body } = api.payLater(
      orderId,
      paymentTypeName
    );
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({ type: PAY_LATER_REQUEST, payload: orderId });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          // Response OK => JSON
          return response.json();
        }
        // Response NOT OK
        dispatch({
          type: PAY_LATER_FAILURE,
        });
        browserHistory.push('/checkout-failure');
        throw new Error('Risposta da server non OK su creazione pagamento');
      })
      .then(data => {
        // Here I have the JSON data
        dispatch({
          type: PAY_LATER_SUCCESS,
          payload: data,
        });

        if (data.redirectUrl && data.redirectUrl.indexOf('http') > -1) {
          // Ordine Carta di credito, ho l'URL di redirect => Redirect
          console.log('Order Credit card OK, redirecting to', data.redirectUrl);
          if (window) {
            // Siamo su browser
            window.location = data.redirectUrl;
          }
        } else {
          // Ordine Carta di credito, ma server non mi ha dato URL di Redirect
          // => E' successo qualcosa di strano
          browserHistory.push('/checkout-failure');
          throw new Error('Pagamento CArta di credito senza redirectUrl');
        }
      })
      .catch(error => {
        console.error('Errore durante il salvataggio del pagamento', error);
        dispatch({
          type: PAY_LATER_FAILURE,
        });
        browserHistory.push('/checkout-failure');
      });
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: {
    shipping: {},
    billing: {},
    coupon: {},
    payment: {},
    invoice: {},
    creditMemo: {
      rows: [],
    },
    items: [],
  },
};

export default function singleOrderReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}

export const canPayLater = order => {
  if (
    order.shipping.status === 'bloccato' &&
    (order.payment.typeName === 'paypal' ||
      order.payment.typeName === 'nexi' ||
      order.payment.typeName === 'satispay') &&
    // || order.payment.typeName === 'satispay'
    (order.payment.status === 'in attesa' ||
      order.payment.status === 'errore' ||
      order.payment.status === 'annullato')
  ) {
    return true;
  } else {
    return false;
  }
};
